'use strict';

const _ = require('underscore/underscore.js');
const Constants = require('constants/Constants');
const Events = require('constants/Events');
const ViewportEvents = require('constants/ViewportEvents');
const gsap = require('gsap').default;
const CustomEase = require('../../js/libs/CustomEase.min').default;

const THREE = require('three');

module.exports = {

    remapUVs: function (geo) {
        let max; let min; let offset; let size; let v1; let v2; let v3;

        geo.computeBoundingBox();

        min = geo.boundingBox.min;
        max = geo.boundingBox.max;

        offset = new THREE.Vector2(0 - min.x, 0 - min.y);
        size = new THREE.Vector2(max.x - min.x, max.y - min.y);

        geo.faceVertexUvs[0] = [];

        geo.faces.forEach(face => {
            v1 = geo.vertices[face.a];
            v2 = geo.vertices[face.b];
            v3 = geo.vertices[face.c];

            geo.faceVertexUvs[0].push([
                new THREE.Vector2((v1.x + offset.x) / size.x, (v1.y + offset.y) / size.y),
                new THREE.Vector2((v2.x + offset.x) / size.x, (v2.y + offset.y) / size.y),
                new THREE.Vector2((v3.x + offset.x) / size.x, (v3.y + offset.y) / size.y)
            ]);
        });

        return geo.uvsNeedUpdate = true;
    },

    makeRoundedCornerPlane: function (width = 1, height = 1.7, radius = 1, smooth = 16) {
        const geometry = new THREE.Geometry();

        const cornerA = new THREE.CircleGeometry(radius, smooth, (Math.PI * 2 / 4) * 1, Math.PI * 2 / 4);
        const matrixA = new THREE.Matrix4();
        matrixA.makeTranslation(-width / 2, height / 2, 0);
        geometry.merge(cornerA, matrixA);

        const cornerB = new THREE.CircleGeometry(radius, smooth, (Math.PI * 2 / 4) * 0, Math.PI * 2 / 4);
        const matrixB = new THREE.Matrix4();
        matrixB.makeTranslation(width / 2, height / 2, 0);
        geometry.merge(cornerB, matrixB);

        const cornerC = new THREE.CircleGeometry(radius, smooth, (Math.PI * 2 / 4) * 2, Math.PI * 2 / 4);
        const matrixC = new THREE.Matrix4();
        matrixC.makeTranslation(-width / 2, -height / 2, 0);
        geometry.merge(cornerC, matrixC);

        const cornerD = new THREE.CircleGeometry(radius, smooth, (Math.PI * 2 / 4) * 3, Math.PI * 2 / 4);
        const matrixD = new THREE.Matrix4();
        matrixD.makeTranslation(width / 2, -height / 2, 0);
        geometry.merge(cornerD, matrixD);

        const planeTop = new THREE.PlaneGeometry(width, radius);
        const matrixTop = new THREE.Matrix4();
        matrixTop.makeTranslation(0, -height / 2 - radius / 2, 0);
        geometry.merge(planeTop, matrixTop);

        const planeCenter = new THREE.PlaneGeometry(width + radius * 2, height);
        geometry.merge(planeCenter);

        const planeBottom = new THREE.PlaneGeometry(width, radius);
        const matrixBottom = new THREE.Matrix4();
        matrixBottom.makeTranslation(0, height / 2 + radius / 2, 0);
        geometry.merge(planeBottom, matrixBottom);

        app.utils.remapUVs(geometry);

        return geometry;
    },

   /*eslint-disable */
    easingFunctions: function (st, ed, per, easing) {
        var functions = {
            //simple linear tweening - no easing, no acceleration
            linearTween: function (t, b, c, d) {
                return c * t / d + b;
            },

            // quadratic easing in - accelerating from zero velocity
            easeInQuad: function (t, b, c, d) {
                t /= d;

                return c * t * t + b;
            },

            // quadratic easing out - decelerating to zero velocity
            easeOutQuad: function (t, b, c, d) {
                t /= d;

                return -c * t * (t - 2) + b;
            },

            // quadratic easing in/out - acceleration until halfway, then deceleration
            easeInOutQuad: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t + b;
                t--;

                return -c / 2 * (t * (t - 2) - 1) + b;
            },

            // cubic easing in - accelerating from zero velocity
            easeInCubic: function (t, b, c, d) {
                t /= d;

                return c * t * t * t + b;
            },

            // cubic easing out - decelerating to zero velocity
            easeOutCubic: function (t, b, c, d) {
                t /= d;
                t--;

                return c * (t * t * t + 1) + b;
            },

            // cubic easing in/out - acceleration until halfway, then deceleration
            easeInOutCubic: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t * t + b;
                t -= 2;

                return c / 2 * (t * t * t + 2) + b;
            },

            // quartic easing in - accelerating from zero velocity
            easeInQuart: function (t, b, c, d) {
                t /= d;

                return c * t * t * t * t + b;
            },

            // quartic easing out - decelerating to zero velocity
            easeOutQuart: function (t, b, c, d) {
                t /= d;
                t--;

                return -c * (t * t * t * t - 1) + b;
            },

            // quartic easing in/out - acceleration until halfway, then deceleration
            easeInOutQuart: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t * t * t + b;
                t -= 2;

                return -c / 2 * (t * t * t * t - 2) + b;
            },

            // quintic easing in - accelerating from zero velocity
            easeInQuint: function (t, b, c, d) {
                t /= d;

                return c * t * t * t * t * t + b;
            },

            // quintic easing out - decelerating to zero velocity
            easeOutQuint: function (t, b, c, d) {
                t /= d;
                t--;

                return c * (t * t * t * t * t + 1) + b;
            },

            // quintic easing in/out - acceleration until halfway, then deceleration
            easeInOutQuint: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t * t * t * t + b;
                t -= 2;

                return c / 2 * (t * t * t * t * t + 2) + b;
            },

            // sinusoidal easing in - accelerating from zero velocity
            easeInSine: function (t, b, c, d) {
                return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
            },

            // sinusoidal easing out - decelerating to zero velocity
            easeOutSine: function (t, b, c, d) {
                return c * Math.sin(t / d * (Math.PI / 2)) + b;
            },

            // sinusoidal easing in/out - accelerating until halfway, then decelerating
            easeInOutSine: function (t, b, c, d) {
                return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
            },

            // exponential easing in - accelerating from zero velocity
            easeInExpo: function (t, b, c, d) {
                return c * Math.pow( 2, 10 * (t / d - 1) ) + b;
            },

            // exponential easing out - decelerating to zero velocity
            easeOutExpo: function (t, b, c, d) {
                return c * ( -Math.pow( 2, -10 * t / d ) + 1 ) + b;
            },

            // exponential easing in/out - accelerating until halfway, then decelerating
            easeInOutExpo: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * Math.pow( 2, 10 * (t - 1) ) + b;
                t--;

                return c / 2 * ( -Math.pow( 2, -10 * t) + 2 ) + b;
            },

            // circular easing in - accelerating from zero velocity
            easeInCirc: function (t, b, c, d) {
                t /= d;

                return -c * (Math.sqrt(1 - t * t) - 1) + b;
            },

            // circular easing out - decelerating to zero velocity
            easeOutCirc: function (t, b, c, d) {
                t /= d;
                t--;

                return c * Math.sqrt(1 - t * t) + b;
            },

            // circular easing in/out - acceleration until halfway, then deceleration
            easeInOutCirc: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
                t -= 2;

                return c / 2 * (Math.sqrt(1 - t * t) + 1) + b;
            }
        };

        return functions[easing](per, st, ed - st, 1);
    },
    /*eslint-enable */


    blockScrollOnSwipe: function (el) {
        let x;
        let y;
        let scroll;

        const onTouchStart = function (e) {
            if (e.touches.length > 1) {
                return;
            }

            scroll = undefined;
            x = e.touches[0].pageX;
            y = e.touches[0].pageY;
        };

        const onTouchMove = function (e) {
            if (scroll === 'v') {
                return;
            }

            const dX = e.touches[0].pageX - x;
            const dY = e.touches[0].pageY - y;

            if (scroll === 'h') {
                e.preventDefault();
            } else if (Math.abs(dX) > 5 || Math.abs(dY) > 5) {
                scroll = Math.abs(dX) > Math.abs(dY) ? 'h' : 'v';
            }
        };

        el.addEventListener('touchstart', onTouchStart, {
            passive: false
        });
        el.addEventListener('touchmove', onTouchMove, {
            passive: false
        });
    },

    PageVisibilityManager: (function () {
        // Set the name of the hidden property and the change event for visibility
        let hidden;
        let visibilityChange;
        if (typeof document.hidden !== 'undefined') {
            hidden = 'hidden';
            visibilityChange = 'visibilitychange';
        } else if (typeof document.mozHidden !== 'undefined') {
            hidden = 'mozHidden';
            visibilityChange = 'mozvisibilitychange';
        } else if (typeof document.msHidden !== 'undefined') {
            hidden = 'msHidden';
            visibilityChange = 'msvisibilitychange';
        } else if (typeof document.webkitHidden !== 'undefined') {
            hidden = 'webkitHidden';
            visibilityChange = 'webkitvisibilitychange';
        }

        const add = function (callback) {
            if (!hidden) {
                return false;
            }
            document.addEventListener(visibilityChange, callback);
        };

        const remove = function (callback) {
            if (!hidden) {
                return false;
            }
            document.removeEventListener(visibilityChange, callback);
        };

        const isHidden = function () {
            return document[hidden];
        };

        return {
            addEventListener: add,
            removeEventListener: remove,
            isPageHidden: isHidden
        };
    })(),

    //create blank video and check if it can be autoplayed without direct user interaction or not
    detectVideoAutoplayFeature: function (cb) {
        const base64BlankVideo = 'data:video/mp4;base64,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';
        const $video = $('<video muted playsinline crossorigin loop preload="auto">')
            .attr('src', base64BlankVideo)
            .css({
                'position': 'absolute',
                'top': -9999
            })
            .appendTo('body');
        const playPromise = $video[0].play();

        // browsers that don't yet support this functionality,
        // playPromise won't be defined.
        if (playPromise !== undefined) {
            let res;
            playPromise
                .then(() => {
                    res = true;
                })
                .catch(() => {
                    res = false;
                })
                .finally(() => {
                    $video.remove();
                    cb(res);
                });
        } else {
            $video.remove();
            setTimeout(() => {
                cb(true); //for older browsers autoplay is almost certanly enabled
            }, 100);
        }
    },


    forcePlay: function (video, delay) {
        if (!video) {
            return;
        }

        delay = delay || 100;

        clearTimeout($(video).attr('data-timeout') - 0);

        const startTime = video.currentTime;

        $(video).attr('data-timeout', setTimeout(function () {
            const endTime = video.currentTime;

            if (startTime === endTime) {
                video.pause();
                app.utils.forcePlay(video, delay * 1.5);
            }
        }, 100));

        video.play();
    },


    forcePause: function (video) {
        if (!video) {
            return;
        }

        video.pause();
        clearTimeout($(video).attr('data-timeout') - 0);
    },

    /**
     *
     *  @param params = {
     *             $container: jQuery object - container for video,
     *             className: string - class for video,
     *             path: string - path to video,
     *             callback: function - callback function when video is ready
     *         }
     */
    createVideoSequence: function (params) {
        // console.log('CREATE VIDEO SEQUENCE', params.path);

        // const loadOrder = {
        //     'hero/sequence.mp4': 1,

        //     'features/funding/show.mp4': 2,
        //     'features/cards/show.mp4': 3,
        //     'features/widgets/show.mp4': 4,
        //     'features/controls/show.mp4': 5,

        //     'tailored/tailor_0.mp4': 6,
        //     'tailored/tailor_1.mp4': 7,
        //     'tailored/tailor_2.mp4': 8,
        //     'tailored/tailor_3.mp4': 9,

        //     'features/funding/hover.mp4': 10,
        //     'features/cards/hover.mp4': 11,
        //     'features/widgets/hover.mp4': 12,
        //     'features/controls/hover.mp4': 13,

        //     'features/funding/unhover.mp4': 14,
        //     'features/cards/unhover.mp4': 15,
        //     'features/widgets/unhover.mp4': 16,
        //     'features/controls/unhover.mp4': 17
        // };

        // let order = 0;
        // for (let video in loadOrder) {
        //     if (params.path.indexOf(video) >= 0) {
        //         order = loadOrder[video];
        //     }
        // }
        // let delay = order * 70;

        const $video = $('<video muted playsinline crossorigin preload="auto">')
            .addClass(params.className)
            .attr('src', params.path)
            .appendTo(params.$container);

        const callback = params.callback || (() => {});

        const video = $video[0];

        // setTimeout(function () {
        //     console.log('TIMEOUT', params.path);

        let playPromise = video.play();

        if (typeof playPromise !== 'undefined') {
            playPromise
                .then(() => {
                    // console.log('PLAY PROMISE THEN', params.path);
                    video.pause();
                    video.currentTime = 0;
                    callback();
                })
                .catch(() => {
                    // console.log('PLAY PROMISE CATCH', params.path, e);
                    video.pause();
                    video.currentTime = 0;
                    callback();
                });
        } else {
            try {
                video.pause();
                video.currentTime = 0;
                callback();
            } catch (error) {
                callback();
            }
        }
        // }, delay);

        return video;
    },

    /**
     *
     * @param params = {
     *           $container: jQuery object,
     *           className: string - class which  would be added to a single word
     *        }
     */
    splitLineToWords: function (params) {
        const lineString = params.$container.text();

        const words = lineString.split(' ');
        params.$container.empty();

        words.forEach((word, index) => {
            const $wordSpan = $('<span>');
            const wordText = index === 0 ? word : (' ' + word);
            $wordSpan.css('display', 'inline-block');
            $wordSpan.css('white-space', 'pre');
            $wordSpan.addClass(params.className);
            $wordSpan.text(wordText);
            params.$container.append($wordSpan);
        });
    },

    /**
     *
     * @param params = {
     *           $container: jQuery object,
     *           className: string - class which would be added to single line,
     *           autoWidth: boolean - if true, width will be set to 'auto' when resize is in progress,
     *                                otherwise will be set to 100%
     *        }
     *
     * @returns {{cancel: cancel, $container: *, className: *}}
     */
    splitMultilineToSeparateSpans: function (params) {
        const innerHTML = params.$container[0].innerHTML;
        const text = params.$container.text();
        const words = text.split(' ');

        const onResizeStarted = () => {
            params.$container[0].innerHTML = innerHTML;
        };


        const onResizeEnded = () => {
            //fix container height to prevent other content on page repaint
            const height = params.$container.height();

            params.$container.css({
                overflow: 'hidden',
                height: height
            });

            //remove previous division
            params.$container.empty();

            let line = '';
            let prevLine = '';
            let $span;
            let oneLineHeight;
            let index = 0;

            for (let i = 0; i < words.length; i++) {
                prevLine = line;
                line += words[i] + ' ';

                if (!prevLine) {
                    //in some rare cases new line doesn't go on new line (cause last space in line doesn't render)
                    if ($span) {
                        $('<br>').appendTo(params.$container);
                    }
                    $span = $('<span>')
                        .css({
                            'display': 'inline-block',
                            'width': params.autoWidth ? 'auto' : '100%',
                            'opacity': params.transparent ? '0' : '',
                            'will-change': 'opacity, transform'
                        })
                        .attr('data-index', ++index)
                        .addClass(params.className)
                        .appendTo(params.$container);
                }

                $span.text(line);

                if (!prevLine) {
                    oneLineHeight = $span.height();
                }

                //if current word jumps to second line
                if ($span.height() > oneLineHeight * 1.5) {
                    $span.text(prevLine);
                    i--;
                    line = '';
                }
            }

            //reset fixed height
            params.$container.css({
                overflow: '',
                height: ''
            });
        };

        onResizeEnded();

        app.vent.on(Events.common.resizeStarted, onResizeStarted);
        app.vent.on(Events.common.resizeEnded, onResizeEnded);

        return {
            $container: params.$container,
            className: params.className,
            cancel: function (needRevert) {
                app.vent.off(Events.common.resizeStarted, onResizeStarted);
                app.vent.off(Events.common.resizeEnded, onResizeEnded);
                needRevert && (params.$container[0].innerHTML = innerHTML);
            }
        };
    },

    initGsap: function () {
        window.gsap = gsap;
        CustomEase.create('topNavLogo', 'M0,0 C0,0 0.03717,0.00939 0.05241,0.02135 0.07646,0.04022 0.09435,0.05948 0.11201,0.08787 0.22376,0.26757 0.28273,0.38851 0.3973,0.57591 0.42952,0.62861 0.45149,0.65714 0.48954,0.70538 0.52211,0.74666 0.54268,0.77076 0.57977,0.80719 0.61585,0.84263 0.63995,0.86385 0.68053,0.89298 0.71627,0.91864 0.74152,0.93353 0.78117,0.95177 0.81871,0.96905 0.84552,0.97851 0.88564,0.98736 0.92746,0.99657 1,1 1,1 ');
    },

    /**
     *
     * @param object = {
     *     $container: jQuery object with text container with lines,
     *     className: string - class name for single line,
     *     cancel: function - if we need to disable split after animation
     * }
     * @param params = {
     *     lineDuration: number in milliseconds - duration of animation for single line,
     *     lineDelay: number in milliseconds - delay between lines animation,
     *     cancelOnEnd: boolean - if we need to call object.cancel() after animation ends,
     *     shift: number - vertical shift of line,
     *     delay: number in milliseconds - delay before whole animation,
     *     backwards: boolean - if animation should go backwards
     * }
     * @param callback function called after animation ended
     * @returns length of $lines
     */
    animateTextByLines: function (object, params, callback) {
        const $lines = object.$container.find('.' + object.className);

        const secondsDivider = 1000;

        const shift = params.shift || 30;
        const delay = params.delay / secondsDivider || 0;
        const lineDuration = params.lineDuration / secondsDivider || 0;
        const lineDelay = params.lineDelay / secondsDivider || 0;
        const timeline = gsap.timeline({
            onComplete: () => {
                $lines
                    .css({
                        transform: '',
                        opacity: ''
                    });
                params.cancelOnEnd && object.cancel(true);
                callback && callback();
            }
        });

        const fromParams = {
            y: params.backwards ? 0 : shift,
            opacity: params.backwards ? 1 : 0.01
        };

        const toParams = {
            y: params.backwards ? shift : 0,
            opacity: params.backwards ? 0.01 : 1,
            duration: lineDuration,
            ease: 'expo.out'
        };

        $lines.each((index, line) => {
            const singleLineDelay = delay + lineDelay * index;
            timeline.fromTo(line, fromParams, toParams, singleLineDelay);
        });

        return $lines.length;
    },


    waitForTransitionEnd: function ($obj, property, cb, safeTimeout) {
        const transEndEventNames = {
            'transition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd',
            'MozTransition': 'transitionend',
            'OTransition': 'oTransitionEnd',
            'msTransition': 'MSTransitionEnd'
        };

        const getTransitionEndName = function () {
            if (!window.getComputedStyle || !document.documentElement) {
                return 'transitionend';
            }

            const styles = window.getComputedStyle(document.documentElement, '');

            for (let i in transEndEventNames) {
                if (styles[i] !== undefined) {
                    return transEndEventNames[i];
                }
            }

            return 'transitionend';
        };

        const transEndEventName = getTransitionEndName();

        let transitionSafeTimeout = 0;

        const transitionEndCallback = function (e) {
            if (e) {
                const prop = e.originalEvent.propertyName.toLowerCase();
                if (!$(e.target)
                    .is($obj)) {
                    return;
                }
                if (prop.indexOf(property) === -1) {
                    return;
                }
            }

            $obj.off(transEndEventName, transitionEndCallback);

            clearTimeout(transitionSafeTimeout);

            cb();
        };

        const resetAllHandlers = function () {
            $obj.off(transEndEventName, transitionEndCallback);

            clearTimeout(transitionSafeTimeout);
        };


        $obj.on(transEndEventName, transitionEndCallback);

        transitionSafeTimeout = setTimeout(transitionEndCallback,
            safeTimeout === undefined ? this.getTransitionDuration($obj[0], property) + 100 : safeTimeout);

        return resetAllHandlers;
    },

    startImagesRotation: function (self, parentSelector, duration, delay) {
        let current = 0;
        let images = [];
        let zIndex = 1;
        let state = {};
        let startTimeout;
        let nextTimeout;

        const loadNext = function () {
            const next = (current + 1) % images.length;
            if (images[next].isLoadingStarted) {
                return;
            }

            images[next].$image
                .each(function () {
                    $(this)
                        .attr('srcset', $(this)
                            .attr('data-srcset'));
                    $(this)
                        .removeAttr('data-srcset');
                });

            images[next].$image.attr('src', images[next].$image.attr('data-src'));
            images[next].$image.removeAttr('data-src');
            images[next].$image.css('display', '');

            images[next].isLoadingStarted = true;
        };

        const start = function () {
            clearTimeout(startTimeout);
            clearInterval(nextTimeout);

            startTimeout = setTimeout(function () {
                nextTimeout = setInterval(function () {
                    images[current].$image.addClass('fade-out');

                    current = (current + 1) % images.length;
                    images[current].$image
                        .removeClass('fade-out')
                        .addClass('fade-in')
                        .css('z-index', ++zIndex);

                    setTimeout(function () {
                        images[current].$image.removeClass('fade-in');
                    }, 17);

                    loadNext();
                }, duration);
            }, delay);
        };

        self.$(parentSelector + ' img')
            .each(function () {
                images.push({
                    isLoadingStarted: !!$(this)
                        .attr('src'),
                    $image: $(this)
                });
            });

        setTimeout(loadNext, 500 + delay);
        start();


        return {
            pause: function (tp) {
                if (state[tp] === 'paused') {
                    return;
                }

                clearTimeout(startTimeout);
                clearInterval(nextTimeout);

                state[tp] = 'paused';
            },
            resume: function (tp) {
                if (state[tp] === 'playing') {
                    return;
                }
                state[tp] = 'playing';

                const isAllPlaying = _.every(state, function (item) {
                    return item === 'playing';
                });

                isAllPlaying && start();
            }
        };
    },

    fixHeightOnIos: function ($el) {
        let vh = $(window)
            .height();
        $el.css('height', `${vh}px`);
    },

    onVisibileInViewport: function ($el, callback) {
        if ('IntersectionObserver' in window) {
            const imageObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        const item = entry.target;
                        callback();
                        imageObserver.unobserve(item);
                    }
                });
            });

            imageObserver.observe($el[0]);
        } else {
            const checkVisible = _.throttle(function () {
                if ($el.offset().top < ($(window)
                    .height() + $(window)
                    .scrollTop())) {
                    callback();
                    $(window)
                        .off('resize scroll orientationchange', checkVisible);
                }
            }, 100);

            $(window)
                .on('resize scroll orientationchange', checkVisible);

            checkVisible();
        }
    },

    getScrollY: function () {
        return window.scrollY || window.pageYOffset || document.body.scrollTop;
    },

    setMetaTags: function (metaList) {
        metaList.forEach(({
            kind,
            name,
            value
        }) => {
            const query = `meta[${kind}="${name}"]`;
            document.querySelector(query)
                .setAttribute('content', value);
        });
    },

    setTitle: function (title) {
        document.title = title;
    },

    changeHash: function (newHash) {
        window.app.state.isHashChanging = true;
        window.location.hash = newHash;
        setTimeout(() => {
            window.app.state.isHashChanging = false;
        });
    },

    removeHash: function () {
        const hash = '#/';
        window.app.utils.changeHash(hash);
    },

    attachClickOnAnchorLinks: function () {
        $(Constants.selectors.anchorLink)
            .off(ViewportEvents.click, this.onAnchorClick);
        $(Constants.selectors.anchorLink)
            .on(ViewportEvents.click, this.onAnchorClick);
    },

    onAnchorClick: function (e) {
        e.preventDefault();
        const aid = $(this)
            .attr('href');
        const scrollTop = $(aid)[0]
            .offsetTop - 50;
        const scrollElementSelector =
            window.app.commonSelectors.popupWrapper;
        $(scrollElementSelector)
            .animate({
                scrollTop: scrollTop
            }, 'slow');
    },

    processFiredEvent: function (eventName, events = [], callback = () => {}) {
        events.forEach((event) => {
            if (eventName === event.name) {
                event.fired = true;
            }
        });

        if (events.filter(event => !event.fired).length) {
            return;
        }

        callback();
    },

    /**
     *
     * @param events = [
     *          {
     *              name: string,
     *              object: object event should be attached on (optional),
     *              callback: function (optional)}
     *          }
     *      ]
     * @param callback - function to call when all events in list fired
     *
     */
    waitForEvents: function (events = [], callback = () => {}) {
        events.forEach((event) => {
            const object = event.object || app.vent;

            object.on(event.name, () => {
                event.callback && event.callback();
                app.utils.processFiredEvent(event.name, events, callback);
            });
        });
    }
};
